<template>
  <div class="bg-gray-21 p-3">
    <div class="d-flex justify-content-end">
      <action-button
        class="btn-warning-outline px-4 py-2 mr-2"
        :text="$t('GoBack')"
        i="fa fa-arrow-circle-left"
        @click="$router.go(-1)"
      />
      <action-button
        class="btn-warning px-4 py-2 mr-2"
        :text="$t('createuser')"
        i="fa fa-add"
        @click="onCreateHandler()"
      />
    </div>

    <div class="admin-user-profile-view card mt-4">
      <div class="card-body p-5">
        <div class="row">
          <div class="col-2">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Adminusersearch.text')}}:
            </div>
            <custom-input v-model="model.searchUser" />
          </div>
          <div class="col-3">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Adminuserrol.text') | capitalize }}:
            </div>
            <custom-drop-down
              label=""
              placeholder="Seleccione"
              :options="options.roles"
              fieldkey="id"
              fieldname="name"
              v-model="model.role"
              @input="() => {}"
            />
          </div>
          <div class="col-3">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Adminuseremail.text') | capitalize }}:
            </div>
            <custom-input v-model="model.email" />
          </div>
          <div class="col-2">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Adminuserphone.text') | capitalize }}:
            </div>
            <custom-input v-model="model.phone" />
          </div>
          <div class="col-2 mt-4">
            <action-button
              class="btn-warning px-4 py-2"
              :text="$t('Search')"
              i="fa fa-search"
              @click="onSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <separator-extended :text="$t('result')" />
            <custom-result-not-found v-if="emptyResults" />
            <div
              v-for="(item, index) in results.data"
              :key="`result-item-${index}`"
              class="mx-3"
            >
              <div class="row bg-gray rounded p-3 mb-2">
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    {{ $t('txtForgotAnswerOfQuestionUsername') }}
                  </div>
                  <div class="color-black font-16">{{ item.userName }}</div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    {{ $t('Adminuserrol.text')}}:
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.roleName }}
                  </div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Email:
                  </div>
                  <div class="color-black font-16">
                    {{ item.email }}
                  </div>
                </div>
                <div
                  class="col d-flex flex-row justify-content-end align-items-center"
                >
                  <action-button
                    class="outline-success mr-2"
                    :text="$t('edit')"
                    i="fas fa-pencil"
                    @click="editUser(item)"
                  />

                  <action-button
                    class="outline-danger"
                    :text="$t('delete')"
                    i="fas fa-close"
                    @click="deleteUser(item)"
                  />
                </div>
              </div>
            </div>
            <pagination
              v-if="
                results.data.length > 0 &&
                pagination.totalItemCount > pagination.pageSize
              "
              :show-text="true"
              @pagination-go-page="goToPageHandler"
              :data="pagination"
              
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//components
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import SeparatorExtended from '../../components/common/SeparatorExtended.vue';
//services
//   import { getProfileInformation as _getProfileInformation } from '@/services/app.api.js';
import { getRoles as _getRoles, deleteUser } from '@/services/app.api.js';
import { getUsers as _getUsers } from '@/services/auth.api.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'AdminUserProfileView',
  components: {
    //UserProfile,
    CustomInput,
    ActionButton,
    CustomDropDown,
    Pagination,
    CustomResultNotFound,
    SeparatorExtended,
  },
  mixins: [alertMixin],
  data: () => ({
    model: {
      searchUser: '',
      role: '',
      email: '',
      phone: '',
    },
    options: {
      roles: [],
    },
    results: {
      data: [],
    },
    //profileInfo: null,
  }),
  async mounted() {
    this.disposeCaseInfo();
    this.onLoadOptions();
  },
  methods: {
    async onLoadOptions() {
      this.options.roles = (await _getRoles()).data;
      await this.onSearch();
    },
    async onSearch(page) {
      if (page == undefined) {
        page = 1;
      }
      this.results = (
        await _getUsers(
          this.model.searchUser,
          this.model.role.id,
          this.model.email,
          this.model.phone,
          page
        )
      ).data;
    },
    goToPageHandler(page) {
      this.onSearch(page);
    },
    editUser(item) {
      this.$router.push({
        name: 'user-profile',
        params: { userId: item.userId },
      });
    },
    async deleteUser(item) {
      const answer = await this.ShowCancelModal(
        'Eliminar Usuario',
        '¿Está seguro que desea eliminar el usuario?',
        'Si',
        'No'
      );
      if (answer) {
        await deleteUser(item.userId)
        this.ShowToast(
          'Proceso exitoso',
          'El usuario ha sido removido exitosamente.',
          'success'
        );
       
        
        this.onSearch(item);
      }
    },
  },
  computed: {
    emptyResults() {
      return this.results.length === 0;
    },
    pagination() {
      return {
        totalItemCount: this.results.totalItemCount,
        pageSize: 10,
        currentPage: this.results.currentPage,
        pageCount: this.results.pageCount,
      };
    },
    onCreateHandler() {
      this.$router.push({
        name: 'createuser',
        params: {
          userId: this.$route.params.userId,
        },
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.rb__extended ::v-deep {
  .col-12 {
    margin-left: -24px !important;
  }
}
</style>
